import AddIcon from '@mui/icons-material/Add';
import { useMediaQuery, Theme } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { SxProps } from '@mui/system';
import { MouseEventHandler, ReactElement } from 'react';
import { AppBaseButton } from 'components/AppBaseButton/AppBaseButton';

type Props = {
  hideTextWhenXS?: boolean;
  'data-testid'?: string;
  buttonText?: string;
  icon?: JSX.Element;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  variant?: 'text' | 'outlined' | 'contained' | undefined;
  color?: string | undefined;
  transformButtonText?: boolean;
};

export function ShrinkToIconButton({
  hideTextWhenXS = true,
  buttonText = 'button',
  'data-testid': testId = undefined,
  icon = <AddIcon />,
  onClick = undefined,
  variant,
  color,
  transformButtonText = true,
}: Props): ReactElement {
  const replaceButton = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm')) && hideTextWhenXS;
  const iconButton = <IconButton onClick={onClick}>{icon}</IconButton>;
  const textStyle: SxProps<Theme> = transformButtonText ? {} : { letterSpacing: 0, textTransform: 'none' };

  const button = (
    <AppBaseButton
      variant={variant}
      sx={{
        ...textStyle,
        color: { color },
      }}
      startIcon={icon}
      onClick={onClick}
      data-testid={testId}
    >
      {buttonText}
    </AppBaseButton>
  );

  return replaceButton ? iconButton : button;
}
